module.exports = __webpack_public_path__ + "media/src/images/icon__happy--4-2f657351c86311eb64dd229d5b3d4fea.png";